import { Button } from '@iwoca/orion';
import { FieldArrayWithId } from 'react-hook-form';
import styles from './DebtTabs.module.css';

type TProps = {
  debts: FieldArrayWithId[];
  targetDebtIndex: number;
  setTargetDebtIndex: (index: number) => void;
  debtHasError?: (index: number) => boolean;
};

export const DebtTabs = ({
  debts,
  targetDebtIndex,
  setTargetDebtIndex,
  debtHasError,
}: TProps) => {
  if (debts.length <= 1) {
    return null;
  }

  return (
    <div className={styles.tabs}>
      {debts.map((debt, index) => (
        <Button
          key={debt.id}
          data-testid={`debt-tab-${index + 1}`}
          size="small"
          type="button"
          className={debtHasError?.(index) ? styles.tabError : undefined}
          onClick={() => setTargetDebtIndex(index)}
          variant={index === targetDebtIndex ? 'denim' : 'secondary-alt'}
        >
          Debt {index + 1}
        </Button>
      ))}
    </div>
  );
};
